import { render } from "./ChargebeeUpsellTag.vue?vue&type=template&id=5753771c&scoped=true"
import script from "./ChargebeeUpsellTag.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellTag.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellTag.vue?vue&type=style&index=0&id=5753771c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5753771c"]])

export default __exports__